import React from 'react';
import TableCell from '@mui/material/TableCell';
import type { FC, ReactNode } from 'react';

interface TableCellProps {
  id: string;
  children?: ReactNode;
  className?: string;
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  padding?: 'checkbox' | 'none' | 'normal';
  size?: 'medium' | 'small';
  sortDirection?: 'asc' | 'desc' | false;
  variant?: 'body' | 'footer' | 'head';
  colspan?: number;
  rowSpan?: number;
  onClick?: (event: React.MouseEvent<HTMLTableCellElement>) => void;
}

const CustomTableCell: FC<TableCellProps> = ({
  id,
  children,
  className,
  align,
  padding,
  size,
  sortDirection,
  onClick,
  variant,
  colspan,
  rowSpan,
  ...rest
}) => {
  return (
    <TableCell
      id={id}
      className={className}
      padding={padding}
      size={size}
      align={align}
      variant={variant}
      sortDirection={sortDirection}
      onClick={onClick}
      colSpan={colspan}
      rowSpan={rowSpan}
      {...rest}
    >
      {children}
    </TableCell>
  );
};

export default CustomTableCell;
